function App() {
	return (
		<div className="wrapper">
			<img src="/images/MD.png" alt="MyDrama" className="blushed-bg" />
			{/* <img src="/images/footer.png" alt="footer" className="blushed-footer" /> */}
			<div className="policy-wrapper">
				{/* <div className="line" /> */}
				<div className="policy-item">
					All Rights Reserved © 2024 . <br />
					HOLY WATER LIMITED <br />
					Lykavitou, 46, Egkomi, 2401, Nicosia, Cyprus
				</div>
				<a
					href="https://my-drama.com/terms-of-use"
					target="_blank"
					rel="noopener noreferrer"
					style={{ textDecoration: 'none' }}
				>
					<div className="policy-item">Terms</div>
				</a>
				<a
					href="https://my-drama.com/privacy-policy-terms"
					target="_blank"
					rel="noopener noreferrer"
					style={{ textDecoration: 'none' }}
				>
					<div className="policy-item">Privacy</div>
				</a>
				<a
					href="https://my-drama.com/subscription-terms"
					target="_blank"
					rel="noopener noreferrer"
					style={{ textDecoration: 'none' }}
				>
					<div className="policy-item">Subscription terms</div>
				</a>
			</div>
		</div>
	);
}

export default App;
